<template>
  <div class="table">
    <!-- <div class="search">
      <div class="searchItem">
        <p class="searchLabel">派发状态</p>
        <div class="searchInfo">
          <el-radio-group v-model="formes.status" @change="esarchang(1)">
            <el-radio-button :label="2">全部</el-radio-button>
            <el-radio-button :label="1">已派发</el-radio-button>
            <el-radio-button :label="0">未派发</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div> -->
    <div
      ref="caozuo"
      style="display: flex; justify-content: space-between; margin-bottom: 10px"
    >
      <div>
        <el-button size="small" @click="backtrack">
          <i class="el-icon-back"></i> 返回
        </el-button>
        <el-button size="small" @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <!-- <el-dropdown trigger="click" style="margin-left: 10px">
          <el-button size="small">
            <i class="el-icon-upload2"></i>
            导出
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="daochu3">选定</el-dropdown-item>
            <el-dropdown-item @click.native="daochu">全部</el-dropdown-item>
            <el-dropdown-item @click.native="daochu4"
              >搜索结果</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>

      <el-form :model="formes" :inline="true" label-width="90px">
        <el-form-item label style="margin-bottom: 0">
          <el-select
            v-model="select"
            placeholder="请选择"
            size="small"
            class="especially"
            style="width: 110px"
            @change="changeSelect"
          >
            <el-option label="授权ID" :value="1"></el-option>
            <el-option label="使用用户" :value="2"></el-option>
          </el-select>
          <el-input
            @input="inputsearch"
            placeholder="请输入"
            size="small"
            v-model="formes.keywords"
            style="width: 160px"
            class="especially2"
            clearable
          >
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="授权ID"></el-table-column>
      <!-- <el-table-column prop="created_at" label="添加时间"></el-table-column> -->
      <el-table-column prop="toUserInfo" label="使用用户">
        <template slot-scope="scope">
          <span v-if="scope.row.toUserInfo.name">{{
            scope.row.toUserInfo.name
          }}</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column prop="fromUserInfo" label="操作用户">
        <template slot-scope="scope">
          <span v-if="scope.row.fromUserInfo.name">
            {{ scope.row.fromUserInfo.name }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="manage_user_id" label="派发状态">
        <template slot-scope="scope">
          <div :class="[scope.row.status ? 'Success' : '']">
            {{ scope.row.status ? "已派发" : "未派发" }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="end_time" label="到期时间"> </el-table-column>
      <!-- <el-table-column prop="use_user_time" label="使用时间"> </el-table-column> -->

      <!-- <el-table-column prop="status" label="使用状态">
        <template slot-scope="scope">
          <div
            :class="[
              scope.row.status == 0
                ? 'Success'
                : scope.row.status == 1
                ? 'Warning'
                : 'red',
            ]"
          >
            {{
              scope.row.status == 0
                ? "未使用"
                : scope.row.status == 1
                ? "已使用"
                : "已过期"
            }}
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
import { debounce } from "@/utils/tool.js";
export default {
  data() {
    return {
      zhanshi: "800px",
      select: 1,
      formes: {
        status: "2",
        keywords: "",
        call_type_id: "",
      },
      call_type_id: "",
      ids: [],
      // 文件
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
    };
  },
  created() {
    this.call_type_id = this.$route.params.call_type_id;
    this.getMainData();
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 189;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = that.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 189;
    };
  },
  methods: {
    changeSelect() {
      this.formes.keywords = "";
      this.esarchang(1);
    },
    inputsearch: debounce(function(e) {
      this.esarchang(1);
    }),
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((i) => {
        this.ids.push(i.id);
      });
    },
    //搜索
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let formes = {
        status: this.formes.status,
        pagesize: this.pagesize,
        page: this.currentPage,
        call_type_id: this.$route.params.call_type_id,
      };
      if (this.formes.status == 2) {
        delete formes.status;
      }
      if (this.formes.keywords) {
        if (this.select == 1) {
          formes.id = this.formes.keywords;
        } else {
          formes.to_name = this.formes.keywords;
        }
      }
      getData("call.CallSeatLogController/pageAction", formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    // 返回
    backtrack() {
      this.$router.go(-1);
    },
    //刷新
    shuaxin() {
      this.currentPage = 1;
      this.pagesize = 20;
      this.formes = { keywords: "", status: "2", call_type_id: "" };
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData() {
      let formes = {
        pagesize: this.pagesize,
        page: this.currentPage,
        call_type_id: this.$route.params.call_type_id,
      };
      getData("call.CallSeatLogController/pageAction", formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.currentPage = res.data.current_page;
        this.pagesize = res.data.per_page;
      });
    },
    // 全部导出
    daochu() {
      location.href =
        this.hostName +
        "/Business/CouponItemExportAction" +
        "&&excel=2" +
        "&&coupon_id=" +
        this.$route.params.id +
        "&&token=" +
        sessionStorage.getItem("token");
      this.$message.success("正在导出！");
    },
    // 选中导出
    daochu3() {
      if (this.ids.length > 0) {
        location.href =
          this.hostName +
          "/Business/CouponItemExportAction?excel=1&&ids=" +
          this.ids +
          "&&coupon_id=" +
          this.$route.params.id +
          "&&token=" +
          sessionStorage.getItem("token");
        this.$message.success("正在导出！");
      } else {
        this.$message({
          message: "请先选择一条要导出的通话",
          type: "warning",
        });
      }
    },
    daochu4() {
      if (
        (this.formes.keywords !== "" && this.tableData.length !== 0) ||
        (this.formes.status !== 2 && this.tableData.length !== 0) ||
        (this.formes.object !== 4 && this.tableData.length !== 0)
      ) {
        let str = "";
        if (this.formes.status !== 2) {
          str = "&&status=" + this.formes.status;
        }
        if (this.formes.object !== 4) {
          str = str + "&&object=" + this.formes.object;
        }
        location.href =
          this.hostName +
          "/Business/CouponItemExportAction?excel=3" +
          "&&keywords=" +
          this.formes.keywords +
          str +
          "&&coupon_id=" +
          this.$route.params.id +
          "&&token=" +
          sessionStorage.getItem("token");
        this.$message.success("正在导出！");
      } else {
        this.$message.error("请先搜索/数据不能为空");
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    // 分页
    current_change: function(currentPage) {
      this.page = currentPage;
      this.currentPage = currentPage;
      this.esarchang();
    },
  },
  watch: {
    $route() {
      this.formes.status = 2;
      setTimeout(() => {
        var caozuo = this.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        this.zhanshi = H - caozuo - 60 - 38 - 15 - 115 - 15;
      }, 100);
      const that = this;
      window.onresize = () => {
        var caozuo = that.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        that.zhanshi = H - caozuo - 60 - 38 - 15 - 115 - 15;
      };
    },
  },
};
</script>

<style lang="less" scoped>
.Success {
  color: #67c23a;
}
.Danger {
  color: #f56c6c;
}
.Warning {
  color: #e6a23c;
}
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.search {
  border: 1px solid #f0f0f0;
  margin: 16px 0;
  &Item {
    display: flex;
    height: 40px;
    border-bottom: 1px dashed #eee;
    &:last-child {
      border-bottom: 0;
    }
  }
  &Label {
    width: 120px;
    background: #f7f7f7;
    padding-left: 20px;
    line-height: 40px;
    display: block;
    height: 40px;
    margin: 0;
    font-size: 12px;
    color: #999;
  }
  &Info {
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
}
.search /deep/ .el-form-item__content {
  line-height: 40px;
}
.searchItem
  /deep/
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  color: #409eff;
  background-color: white;
  border-color: none;
  box-shadow: none;
}
.searchItem /deep/ .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
  border-radius: 0;
  box-shadow: none !important;
}
.searchItem /deep/ .el-radio-button__inner {
  border: none;
  font-size: 12px;
  padding: 12px 15px;
}
.searchItem /deep/ .el-radio-button {
  /*双击文字、input等，出现的蓝色底色，如何去除*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  /*-khtml-user-select:none;!*早期浏览器*!*/
  user-select: none;
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
#title {
  height: 68px;
  line-height: 68px;
  font-size: 21px;
  padding: 0 40px;
  background-color: #fff;
  margin: 0;
  border-bottom: 1px solid #e1e1e1;
}
.main {
  //   margin-top: 15px;
  background-color: #fff;
  height: 90%;
  .w {
    padding: 26px 24px;
    height: 90%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    .tab {
      margin-top: 26px;
    }
    .dialog-footer {
      width: 50%;
      height: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      // border-top: 1px solid #e1e1e1;
      margin-left: 130px;
      position: fixed;
      right: 0;
      bottom: 0;
      background-color: #fff;
      .el-button + .el-button {
        margin-right: 20px;
      }
    }
  }
}
</style>
<style src="@/assets/css/index.css" scoped></style>
